module.exports = __webpack_public_path__ + "static/media/web-design-certificate-of-training.389ec491.jpg";